// Need to use the React-specific entry point to import createApi
import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from '../baseQuery';
import { type DefectsRequestModel, type DefectsResponseModel, type Diagnostics, type DiangosticRequestModel, type SavInfo, type SavInfoRequestModel } from './savModels';

export const savApi = createApi({
  reducerPath: 'savApi',
  baseQuery: baseQuery('public/sav'),
  endpoints: (builder) => {
    return {
      getFamilyDefects: builder.query<DefectsResponseModel, DefectsRequestModel>({
        query: ({ lang, pays_uuid, famille }) => {
          return {
            url: `defauts/familles/${famille}`,
            method: 'get',
            params: {
              pays_uuid,
              lang,
            },
          };
        },
      }),

      getProductDefects: builder.query<DefectsResponseModel, DefectsRequestModel>({
        query: ({ lang, univers_uuid, pays_uuid, famille, produit }) => {
          return {
            url: `defauts/produits/${famille}/${produit}`,
            method: 'get',
            params: {
              lang,
              univers_uuid,
              pays_uuid,
            },
          };
        },
      }),

      getDiagnosticsByFamily: builder.query<Diagnostics[], DiangosticRequestModel>({
        // @ts-ignore
        query: ({ lang, univers_uuid, pays_uuid, defaut, famille }) => {
          return {
            url: `diagnostics/familles/${defaut}/${famille}`,
            method: 'get',
            params: {
              lang,
              //univers_uuid,  ??????????
              pays_uuid,
            },
          };
        },
      }),
      getDiagnosticsByProduct: builder.query<Diagnostics[], DiangosticRequestModel>({
        query: ({ lang, univers_uuid, pays_uuid, defaut, famille, produit }) => {
          return {
            url: `diagnostics/produits/${defaut}/${famille}/${produit}`,
            method: 'get',
            params: {
              lang,
              univers_uuid,
              pays_uuid,
            },
          };
        },
      }),
      getSavInfosByProduct: builder.query<SavInfo[][], SavInfoRequestModel>({
        query: ({ lang, pays_uuid, product_uuid }) => {
          return {
            url: `infos/produits/${product_uuid}`,
            method: 'get',
            params: {
              lang,
              pays_uuid,
            },
          };
        },
      }),
    };
  },
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetFamilyDefectsQuery,
  useGetProductDefectsQuery,
  useGetSavInfosByProductQuery,
  useGetDiagnosticsByProductQuery,
  useLazyGetDiagnosticsByFamilyQuery,
  useLazyGetDiagnosticsByProductQuery,
} = savApi;
